module.exports = __webpack_public_path__ + "img/215.f50f226b.png";